import { useRouter } from "next/router";
import { getLocationLabel, getTagLabel } from "../../../common/helper";

interface HeroProps {
    type?: string;
    name?: string;
    total?: number;
}

export default function Hero({ type, name, total }: HeroProps) {
    const router = useRouter();

    const levelQuery = router.query.iskustvo as string;
    const tagQuery = router.query.tag as string;
    const locationQuery = router.query.lokacija as string;

    let title = "";
    let subtitle = "";

    switch (type) {
        case "city":
            title = `${name} ${levelQuery ? levelQuery : ""} IT Poslovi`;
            subtitle = `Za programere, QA, dizajnere, marketing i menadžment.`;
            break;
        case "type":
            title = `${name} poslovi`;
            subtitle = `Za seniore, mediore i juniore.`;
            break;
        case "pretraga":
            ({ title, subtitle } = getSearchHeadings(
                locationQuery,
                levelQuery,
                tagQuery
            ));
            break;
        case "tag":
            title = `${getTagLabel(name)} ${
                levelQuery ? levelQuery : ""
            } Poslovi`;
            subtitle = `Za seniore, mediore i juniore.`;
            break;
        case "iskustvo":
            title = `${name} IT Poslovi`;
            subtitle = `Za programere, QA, dizajnere, marketing i menadžment.`;
            break;
        default:
            title = "Najveća baza IT poslova i firmi u Bosni i Hercegovini";
            break;
    }

    return (
        <section className="bg-gray-light">
            <div className="pt-10 pb-16 md:py-28 text-center max-w-screen-sm m-auto px-6 lg:px-0">
                <h1
                    className={`md:text-4xl md:leading-snug pb-4 font-semibold ${
                        type && "capitalize"
                    }`}
                >
                    {title}
                </h1>
                {total ? (
                    <p className="font-normal text-gray-dark">
                        Trenutno aktivno{" "}
                        <strong className="text-blue">{total}</strong> poslova
                        unutar <strong className="text-blue">196</strong>{" "}
                        kompanije. Poslovi za developere, dizajnere, QA,
                        marketing i menadžment.
                    </p>
                ) : (
                    <p className="font-normal text-gray-dark">{subtitle}</p>
                )}
            </div>
        </section>
    );
}

/* Odredjuje naslov i podnaslov stranice za razlicite kombinacije parametara pretrage */
function getSearchHeadings(locationQuery, levelQuery, tagQuery) {
    const defaultResult = {
        title: `Rezultati pretrage`,
        subtitle: "Za parametre definisane ispod.",
    };

    if (locationQuery.split(",").length >= 2) return defaultResult;
    if (levelQuery.split(",").length >= 2) return defaultResult;
    if (tagQuery.split(",").length >= 2) return defaultResult;

    const fullSearch = levelQuery && tagQuery && locationQuery;
    const locationAndLevelSearch = locationQuery && levelQuery && !tagQuery;
    const locationAndTagSearch = locationQuery && tagQuery && !levelQuery;
    const tagAndLevelSearch = tagQuery && levelQuery && !locationQuery;

    if (fullSearch) {
        return {
            title: `${getLocationLabel(locationQuery)} ${getTagLabel(
                tagQuery
            )} IT Poslovi`,
            subtitle: `Za ${levelQuery} nivo.`,
        };
    }

    if (locationAndLevelSearch) {
        return {
            title: `${getLocationLabel(
                locationQuery
            )} ${levelQuery} IT Poslovi`,
            subtitle: `Za programere, QA, dizajnere, marketing i menadžment.`,
        };
    }

    if (locationAndTagSearch) {
        return {
            title: `${getLocationLabel(locationQuery)} ${getTagLabel(
                tagQuery
            )} Poslovi`,
            subtitle: `Za seniore, mediore i juniore.`,
        };
    }

    if (tagAndLevelSearch) {
        return {
            title: `${levelQuery} ${getTagLabel(tagQuery)} poslovi`,
            subtitle: `U svim gradovima BiH.`,
        };
    }

    return defaultResult;
}
